import { create } from 'zustand';

interface PermissionsState {
  permissions: Record<string, any>;
  isLoading: boolean;
  setPermissions: (permissions: Record<string, any>) => void;
  setLoading: (loading: boolean) => void;
  getPermissions: () => Record<string, any>;
  clearPermissions: () => void;
}

export const usePermissionsStore = create<PermissionsState>((set, get) => ({
  permissions: {},
  isLoading: true,
  setPermissions: (permissions: Record<string, any>) => {
    set({ permissions, isLoading: false });
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },
  
  getPermissions: () => {
    return get().permissions;
  },
  
  clearPermissions: () => {
    set({ permissions: {}, isLoading: false });
  },
}));
